var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-form-group",
        {
          class: { "no-margin-bottom": _vm.noMarginBottom },
          staticStyle: { "text-align": "initial !important" },
          attrs: {
            label: _vm.label,
            "label-for": _vm.id,
            description: _vm.description
          }
        },
        [
          _c(
            "div",
            [
              _c("b-form-timepicker", {
                attrs: {
                  placeholder: _vm.placeholder,
                  "label-close-button": _vm.$t("close"),
                  "label-decrement": _vm.$t("time-picker.decrement"),
                  "label-increment": _vm.$t("time-picker.increment"),
                  "reset-button": _vm.resetButton,
                  "label-hours": _vm.$t("hours"),
                  "label-minutes": _vm.$t("minutes"),
                  "label-seconds": _vm.$t("seconds"),
                  "label-no-time-selected": _vm.$t(
                    "time-picker.no-time-selected"
                  ),
                  "label-now-button": _vm.$t("time-picker.current-time"),
                  dropup: "",
                  "label-reset-button": _vm.$t("time-picker.reset-btn"),
                  locale: _vm.$i18nHelpers.getNormalizedLocale(),
                  "show-seconds": _vm.showSeconds,
                  "close-button-variant": "secondary",
                  "now-button": _vm.nowButton
                },
                on: {
                  input: function($event) {
                    return _vm.$emit("input", $event)
                  }
                },
                model: {
                  value: _vm.localValue,
                  callback: function($$v) {
                    _vm.localValue = $$v
                  },
                  expression: "localValue"
                }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-db34ee2c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db34ee2c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/forms/BaseTimepicker.vue
// module id = 3171
// module chunks = 7 83